import React from "react";
import { WhmIconButton } from "@securitize/reactjs-whm";
import { DocumentDto } from "../../../../data/types";
import { useDownload } from "./useDownload";

interface Props {
  document: DocumentDto;
}
export const DownloadCell: React.FC<Props> = ({ document }) => {
  const { download, downloading } = useDownload(document);

  return (
    <WhmIconButton
      color="default"
      size="small"
      onClick={() => download(document)}
      disabled={downloading}
      aria-label="download"
    >
      <i className={`wh-icon-download`} />
    </WhmIconButton>
  );
};
